import React from 'react';
import './ScheduleSingle.css';

import { Lightbox, PageSidebar, PageTitle, TeamItem } from '../../../components';
import { getSpeakersByIds } from '../../../utils';
import { speakers } from '../../../constants';

import { FaArrowRight, FaCheck } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const ScheduleSingle = () => {

  // Get the Session data from the router state
  const location = useLocation();  
  const session = location.state; 

  // Get the speakers for this session
  const sessionSpeakers = getSpeakersByIds(session.speakerIds, speakers);

  return (
    <>
      {/* Page Title */}
      <PageTitle title={session.title} page={session.title} />

      <section className='session-single page-single'>

        <div className='session-info page-info'>

          {/* Session Image */}
          <div className='image'>
            <img src={session.image} alt={session.title} />
          </div>

          <div className='content'>

            {/* Session Heading */}
            <h3 className='main-heading'>{session.title}</h3>

            {/* Session Description */}
            {session.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Session Image Gallery */}
            <Lightbox images={session.gallery} className={'service'} />

            {/* Session Agenda Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Session Agenda</h3>

              {/* List of Agenda Points */}
              <ul>
                {session.agenda.map((point, index) => (
                  <li key={index}>
                    <FaArrowRight className='icon' />
                    {point}
                  </li>
                ))}
              </ul>

            </div>

            {/* Learning Outcomes Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Learning Outcomes</h3>

              {/* List of Learning Outcomes */}
              <ul>
                {session.learningOutcomes.map((point, index) => (
                  <li key={index}>
                    <FaCheck className='icon' />
                    {point}
                  </li>
                ))}
              </ul>

            </div>

            {/* Session Speakers Section */}
            <div className='speakers sub-section'>

              <h3 className='sub-heading'>Session Speakers:</h3>

              {/* Speaker List */}
              <div className='box-container'>
                {sessionSpeakers.map((speaker) => (
                  <TeamItem
                    key={speaker.id}
                    team={speaker}
                    type='speaker'
                  />
                ))}
              </div>

            </div>

            {/* Session Venue Map */}
            <div className="session-map sub-section">
              <h3 className="sub-heading">Location Map:</h3>
              <iframe
                src={session.locationMap}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Session Venue Map"
              ></iframe>
            </div>

          </div>

        </div> 

        {/* Sidebar with Session Details */}
        <PageSidebar
          heading={'Session'}
          details={session.details}
          button={{ link: 'Registration', title: 'Register Now' }}
        />

      </section>

    </> 
  );
}

export default ScheduleSingle;